import { isGaEventLoggingFeatureToggleEnabled } from '@/features/app/featureToggles';

declare global {
    interface Window {
        dataLayer?: any[];
    }
}

interface GAEvent {
    event: GoogleAnalyticsCustomEvents;
    parameters: GoogleAnalytics4Parameters;
    // the user props from the first event get propagated to subsequent events,
    // so this will have been set before by the parent FE
    userProps?: GoogleAnalytics4UserProperties;
}

type GoogleAnalyticsCustomEvents =
    | 'vs_selected_columns_in_settings'
    | 'button_show_more'
    | 'filter_criticality'
    | 'filter_sync'
    | 'vs_button_export'
    | 'vs_vehicle_name'
    | 'vs_vehicle_vin'
    | 'vs_customer_name'
    | 'vs_license_plate'
    | 'column_vehicle_info'
    | 'column_maintenance'
    | 'column_wear_and_tear'
    | 'column_dtc_active'
    | 'column_dtc_memory'
    | 'column_warning_messages';

type GoogleAnalytics4Parameters = {
    element_name: string;
    component_name:
        | 'ApplicationLayout'
        | 'ApplicationHeader'
        | 'BottomSheet'
        | 'Sidebar'
        | 'MainNavigation'
        | 'SubNavigation'
        | 'AppNavigationBar'
        | 'Pager'
        | 'Button'
        | 'Checkbox'
        | 'Clearablelnput'
        | 'LoadMoreButton'
        | 'NumberControl'
        | 'RadioButton '
        | 'Slider'
        | 'Switch'
        | 'ToggleButton'
        | 'Collapse'
        | 'Expander'
        | 'Fade'
        | 'AssetTree'
        | 'AutoSuggest'
        | 'ButtonDropdown'
        | 'Select'
        | 'DatePicker'
        | 'FilePicker'
        | 'TimePicker'
        | 'StatusBar'
        | 'SteppedProgress '
        | 'AnimatedNumber'
        | 'Carousel'
        | 'ContentLoader'
        | 'DataTabs'
        | 'Dialog'
        | 'NoData'
        | 'ErrorState'
        | 'NotFoundState'
        | 'EmptyState'
        | 'ForbiddenState'
        | 'MaintenanceState'
        | 'CustomState'
        | 'NotBookedState'
        | 'StatsWidget'
        | 'TableToolbar'
        | 'TableSearch'
        | 'TableViewToggles'
        | 'TableCardsSorting'
        | 'TableSettingDialog'
        | 'Teaser'
        | 'Timeline'
        | 'AreaChart'
        | 'LineChart'
        | 'BarChart'
        | 'PieChart'
        | 'RadialBarChart'
        | 'Map'
        | 'SingleMapMarker'
        | 'ClusterMapMarker'
        | 'Marker';
    trigger: 'click' | 'visibility';
    flow_name?: string;
    identification_type?: string;
    connection_type?: 'inbound' | 'outbound';
    connection_brand?: 'scania' | 'idem' | 'fleetboard' | 'volvo';
    components?: number;
    method?: string;
    search_term?: string;
    currency?: 'Eur' | 'Usd';
    value?: number;
    page_location?: string;
    page_title?: string;
    ecommerce?: object;
    workshop_id?: string;
    asset_id?: string;
    rating?: number;
    callback_requested?: 'yes' | 'no';
    element_state?: string;
};

type GoogleAnalytics4UserProperties = {
    login_method?: 'mobile' | 'email';
    account_id?: string;
    tenant?: string; // rio-eu.test, rio-eu.prod, ...
    user_id?: string;
};

export const gaPush = (gaEvent: GAEvent) => {
    const { event, parameters, userProps } = gaEvent;
    if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.log('[DEVELOPMENT] skip GA4 Event:', event, userProps, parameters);
        return;
    }
    if (isGaEventLoggingFeatureToggleEnabled()) {
        // eslint-disable-next-line no-console
        console.log('[DEBUG] GA4 Event:', event, userProps, parameters);
    }
    if (window.dataLayer) {
        window.dataLayer.push({ event, ...parameters, ...userProps });
    }
};
